import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Eski paylaşılan #forum, #sss gibi hash linklerini path tabanlı rotalara yönlendirir.
 */
export function LegacyHashRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash.replace(/^#/, '').trim();
    if (!hash) return;

    const path = hash.split('?')[0];
    const lower = path.toLowerCase();

    let target: string | null = null;

    if (lower === 'faq' || lower === 'sss') {
      target = '/sss';
    } else if (lower === 'forum' || lower.startsWith('forum/')) {
      target = `/${path}`;
    } else if (lower === 'gizlilik') {
      target = '/privacy';
    } else if (lower === 'telif' || lower === 'copyright') {
      target = '/telif';
    } else if (lower === 'hakkimizda' || lower === 'about') {
      target = '/hakkimizda';
    } else if (lower === 'cerez') {
      target = '/cookies';
    } else if (lower === 'kullanim') {
      target = '/terms';
    } else if (lower === 'terms' || lower === 'privacy' || lower === 'cookies') {
      target = `/${lower}`;
    }

    if (target) {
      navigate(target, { replace: true });
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }, [navigate]);

  return null;
}
